import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ontruck/orc';
import { IS_TENANT } from 'tenant/config';

const t = {
  m: 'm',
};

const HeightCell = React.memo(({ itemHeight }) => {
  if (IS_TENANT) return null;
  return itemHeight ? (
    <span>
      <span>
        <Icon glyph="height" size="1.6rem" color="grey500" />
        {itemHeight} {t.m}
      </span>
    </span>
  ) : null;
});

HeightCell.propTypes = {
  itemHeight: PropTypes.number.isRequired,
};

HeightCell.defaultProps = {
  showIcon: true,
};

export default HeightCell;
